/* Zoheez motion engine — dependency-free scroll/reveal/parallax */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)').matches;

  /* ---------- page curtain ---------- */
  window.addEventListener('load', function () {
    setTimeout(function () { document.body.classList.add('is-loaded'); }, 350);
  });
  setTimeout(function () { document.body.classList.add('is-loaded'); }, 2600);

  /* ---------- split text into chars ---------- */
  function split(el) {
    if (el.dataset.split === 'done') return;
    var walk = el.textContent.trim();
    el.dataset.split = 'done';
    el.innerHTML = walk.split('').map(function (c, i) {
      if (c === ' ') return '<span class="z-space"> </span>';
      return '<span class="z-char" style="transition-delay:' + (i * 22) + 'ms">' + c + '</span>';
    }).join('');
  }
  document.querySelectorAll('[data-split-text]').forEach(split);

  /* ---------- reveal on enter ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    document.querySelectorAll('[data-reveal],[data-split-text]').forEach(function (el) {
      if (el.dataset.revealDelay) el.style.transitionDelay = el.dataset.revealDelay + 'ms';
      io.observe(el);
    });
  } else {
    document.querySelectorAll('[data-reveal],[data-split-text]').forEach(function (el) { el.classList.add('is-in'); });
  }

  if (reduce) return;

  /* ---------- rAF scroll loop: parallax, pin-scrub, header ---------- */
  var parallax = [].slice.call(document.querySelectorAll('[data-parallax]'));
  var pins = [].slice.call(document.querySelectorAll('[data-pin-scroll]'));
  var scrubs = [].slice.call(document.querySelectorAll('[data-scrub]'));
  var header = document.querySelector('[data-header]');
  var lastY = window.scrollY, ticking = false;

  function lerpFrame() {
    var y = window.scrollY;
    var vh = window.innerHeight;

    parallax.forEach(function (el) {
      if (mobile) return;
      var speed = parseFloat(el.dataset.parallax) || 0.15;
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var mid = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (-mid * speed).toFixed(2) + 'px,0)';
    });

    pins.forEach(function (section) {
      var track = section.querySelector('[data-pin-track]');
      if (!track) return;
      var r = section.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var total = section.offsetHeight - vh;
      if (total <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / total));
      var dist = track.scrollWidth - window.innerWidth + 40;
      track.style.transform = 'translate3d(' + (-p * Math.max(dist, 0)).toFixed(2) + 'px,0,0)';
    });

    scrubs.forEach(function (section) {
      var target = section.querySelector('[data-scrub-target]');
      if (!target) return;
      var r = section.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var total = section.offsetHeight - vh;
      if (total <= 0) return;
      var p = Math.min(1, Math.max(0, -r.top / total));
      target.style.transform = '';
      var copy = section.querySelector('[data-scrub-copy]');
      if (copy) {
        copy.style.opacity = '';
        copy.style.transform = '';
      }
    });

    if (header) {
      header.classList.toggle('is-stuck', y > 12);
      if (y > 220 && y > lastY) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
    }
    lastY = y;
    ticking = false;
  }

  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(lerpFrame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  lerpFrame();

  if (mobile) return;

  /* ---------- magnetic buttons ---------- */
  document.querySelectorAll('[data-magnetic]').forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var x = e.clientX - r.left - r.width / 2;
      var y = e.clientY - r.top - r.height / 2;
      el.style.transform = 'translate3d(' + x * 0.28 + 'px,' + y * 0.35 + 'px,0)';
    });
    el.addEventListener('mouseleave', function () { el.style.transform = 'translate3d(0,0,0)'; });
  });

  /* ---------- 3D tilt cards ---------- */
  document.querySelectorAll('[data-tilt]').forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'perspective(900px) rotateY(' + px * 9 + 'deg) rotateX(' + -py * 9 + 'deg) translateY(-8px)';
    });
    el.addEventListener('mouseleave', function () { el.style.transform = ''; });
  });
})();
